import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionHoverEffectsIos() {
    const features = [
        {
            title: 'iOS Consulting Services',
            description:
                'At Moweb, we offer end-to-end iOS software development services by leveraging MVC, Interface Builder, and more. With the help of our highly experienced iOS developers, you can take your product to the next level by making key technical decisions.',
            icon: '/img/technology/ic-consulting-services.svg',
        },
        {
            title: 'Custom iOS App Development',
            description:
                'Using the most recent SDK and technological stack, our iOS experts can create high-end mobile apps to meet your business needs. We provide custom iOS app development by keeping in mind your specifications for impeccable product.',
            icon: '/img/technology/ic-development.svg',
        },
        {
            title: 'iOS UI/UX Design',
            description:
                'We create appealing and user-friendly iOS applications to help your brand stand out and connect with customers. Our UI/UX designers will assist you in conceptualizing and transforming your idea into a successful product.',
            icon: '/img/technology/ic-ios-uiux.svg',
        },
        {
            title: 'iPhone App Development',
            description:
                "We develop next-gen iOS apps that are quality-tested for excellence with our futuristic iOS application development services. Our iOS developers can build feature-rich iPhone app that caters to your target audience unceasingly.",
            icon: '/img/technology/ic-iphone-app.svg',
        },
        {
            title: 'iPad App Development',
            description:
                'We specialize in developing iPad apps by integrating powerful iOS functions to provide an outstanding user experience. We utilize the latest improvements, like Xcode Cloud, to create enterprise-grade mobile apps with rapid development and high security.',
            icon: '/img/technology/ic-ipad-development.svg',
        },
        {
            title: 'iOS Support and Maintenance',
            description:
                'We customize our iOS app support and maintenance packages as per our client\'s business requirements, (i.e., L2-L3 + QA + app evolution). Our experts can assist with bug fixes, system monitoring, performance tuning, and enhanced functionality additions.',
            icon: '/img/technology/ic-support-maintenance.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: string;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
